import React from "react";
import { Text, Button, Modal, ModalBody, ModalFooter } from "@nef/core";
import styled from "styled-components";

const StyledWarningModal = styled(Modal)`
  &.warning-modal {
    div > div {
      top: 50%;
    }
    .text {
      font-size: 16px;
      font-family: sans-serif;
      padding-left: 0.5em;
      padding-top: 1em;
      padding-bottom: 1em;
    }
    Button {
      margin: 0;
    }
  }
`;

export default StyledWarningModal;
